import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { RefProtectionGel } from 'src/app/data/declaration/models/ref-protection-gel.model';
import { RefProtectionGelService } from 'src/app/data/declaration/services/parcellaire/ref-protection-gel.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-edit-protection-gel',
    templateUrl: './edit-protection-gel.component.html',
    styleUrls: ['./edit-protection-gel.component.scss'],
    standalone: false
})
export class EditProtectionGelComponent implements OnInit {
    formGroup: UntypedFormGroup;
    creation = false;
    title: string;
    protectionGel: RefProtectionGel;

    get code() {
        return this.formGroup.get('code');
    }
    get libelle() {
        return this.formGroup.get('libelle');
    }

    constructor(
        private readonly fb: UntypedFormBuilder,
        private readonly loaderService: LoaderService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly protectionGelService: RefProtectionGelService
    ) {}

    ngOnInit() {
        const id = parseInt(this.route.snapshot.paramMap.get('id'), 10);

        if (!id) {
            this.creation = true;
        }
        this.loadData(id);
    }

    loadData(id: number) {
        this.title = this.creation ? 'page.valeur_parametrable.form.title.add_protection_gel' : 'page.valeur_parametrable.form.title.edit_protection_gel';

        if (this.creation) {
            this.protectionGel = new RefProtectionGel();
            this.initForm(null);
        } else {
            this.protectionGelService
                .getRefProtectionGel()
                .pipe(this.loaderService.operator())
                .subscribe(gels => {
                    this.protectionGel = gels.find(g => g.id === id);
                    this.initForm(this.protectionGel && this.protectionGel.id ? this.protectionGel : null);
                });
        }
    }

    private initForm(gel?: RefProtectionGel): void {
        this.formGroup = this.fb.group({
            code: [{ value: gel ? gel.code : undefined, disabled: false }, Validators.required],
            libelle: [{ value: gel ? gel.libelle : undefined, disabled: false }, Validators.required]
        });
    }

    submit() {
        if (this.formGroup.valid) {
            this.protectionGel.code = this.code.value;
            this.protectionGel.libelle = this.libelle.value;

            if (this.protectionGel.id == null) {
                this.protectionGelService.creerRefProtectionGel(this.protectionGel).subscribe(idPprotectionGel => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            } else {
                this.protectionGelService.modifierRefProtectionGel(this.protectionGel).subscribe(() => {
                    this.router.navigate(['.'], { relativeTo: this.route.parent });
                });
            }
        }
    }
}
